const { Configuration } = 
// eslint-disable-next-line @typescript-eslint/no-var-requires
require(`../config/${process.env.BRAND_ID}`);
export const { featuresEnabled, brandName } = Configuration;
export const brandConfiguration = Configuration;
